import * as React from 'react'

import UsDollarsNoticeContainer from '../usDollarsNotice/usDollarsNoticeContainer'

const Magnifier = ({
  name,
  authorName,
  price,
  pricePeriod,
  classification,
  width,
  height,
  children
}: {
  name: string
  authorName: string
  price: string
  pricePeriod: string
  classification: string
  width: number
  height: number
  children: React.ReactNode
}) => {
  return (
    <div className="magnifier" style={{ width }}>
      <div className="size-limiter" style={{ height }}>
        {children}
      </div>
      <strong>{name}</strong>
      <div className="info">
        <div className="author-category">
          by <span className="author">{authorName}</span>
        </div>
        {price ? (
          <div className="price">
            <span className="cost">
              <sup>$</sup>
              {price}
            </span>
            {pricePeriod && (
              <span className="price-period">/{pricePeriod}</span>
            )}
          </div>
        ) : null}
      </div>
      <div className="footer">
        <span className="category">{classification}</span>
        <UsDollarsNoticeContainer styleClassName="gst-notice" />
      </div>
    </div>
  )
}

export default Magnifier
